var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.049,
    height: 15.929,
    viewBox: "0 0 17.049 11.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3309",
    "data-name": "Groupe 3309",
    transform: "translate(1.384 1.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_55",
    "data-name": "Groupe 55",
    transform: "translate(0 3.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_789",
    "data-name": "Trac\\xE9 789",
    d: "M1507.608,393.47h-4.828v-4.828",
    transform: "translate(-1502.78 -387.336)",
    fill: "none",
    stroke: "#ffc25f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_9",
    "data-name": "Ligne 9",
    y1: 6.11,
    x2: 6.11,
    transform: "translate(0.03)",
    fill: "none",
    stroke: "#ffc25f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_56",
    "data-name": "Groupe 56",
    transform: "translate(8.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_789-2",
    "data-name": "Trac\\xE9 789-2",
    d: "M1530.442,376h4.828v4.828",
    transform: "translate(-1529.129 -375.998)",
    fill: "none",
    stroke: "#ffc25f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_9-2",
    "data-name": "Ligne 9-2",
    x1: 6.11,
    y2: 6.11,
    transform: "translate(0 0.024)",
    fill: "none",
    stroke: "#ffc25f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoSwitch);
export default __webpack_public_path__ + "static/media/picto-switch.6043902c90e079a8b9773b7a07c79172.svg";
export { ForwardRef as ReactComponent };